import React from 'react';

const Contact = () => {
  return (
    <div>
      <h1 className="fs-27 color-gray flex flex-col lh-28 fw-600 mb-8">
        <span>Let's Build </span> <span>Something</span> <span>Together</span>
      </h1>
      <div className="color-gray">
        <h2 className="fs-13 fw-600 mb-2">GET IN TOUCH </h2>
        <p className="flex flex-col fs-12 color-gray">
          <span>ashadayosamuel@gmail.com</span> <span>Lagos, Nigeria</span>
        </p>
      </div>
    </div>
  );
};

export default Contact;
